import { Component ,ElementRef,OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource,MatSort, MatPaginator } from '@angular/material';
import { Location } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import * as Highcharts from 'highcharts/highstock';
import Swal from 'sweetalert2'
import HC_exporting from 'highcharts/modules/exporting';
import * as XLSX from 'xlsx'; 
import { YieldReportService } from 'src/app/services/yield-report.service';
import  NoDataToDisplay  from 'highcharts/modules/no-data-to-display';
import { ActivatedRoute } from '@angular/router';
import OfflineOption from 'highcharts/modules/offline-exporting';

HC_exporting(Highcharts);
OfflineOption(Highcharts);
NoDataToDisplay(Highcharts);
declare var $: any;
export interface demo {}
@Component({
  selector: 'smart-yield-report-sub',
  templateUrl: './yield-report-sub.component.html',
  styleUrls: ['./yield-report-sub.component.scss','../platform-color/platform-color.css']
})
export class YieldReportSubComponent implements OnInit {
  role:string=''
  org_id:string=''
  child_org_id:string=''
  farm_id:string=''
  breed_type_id:string=''
  mobile:boolean = false
  show_chart:boolean = false
  data_chart:any=[]
  group_data:any=[]
  // CHART-------------------------------
  chartOptions:any=[]
  Highcharts: typeof Highcharts = Highcharts;
  selectedTypeChart :string = 'percent'
  selectedTypeDetail :string = 'detail_plot'
  selectedTypeData :string = 'data_sum'
  // CHART-------------------------------
  // DATE-FILTER------------------------------
  filter_monthyear_start_show:any=''
  last_select_month:any=''
  filter_monthyear_start:any=''
  @ViewChild('myDivstart') myDivstart: ElementRef;
  @ViewChild('myDivend') myDivend: ElementRef;
  yearselect_start=''
  before_data_month_start:any
  filter_monthyear_end:any=''
  filter_monthyear_end_show:any=''
  before_data_month_end:any
  rollback_css= 'col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 d-flex justify-content-center'
  active_css = 'col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 d-flex justify-content-center activeselect'
  format_month_year=[]
  filter_date:any=[]
  array_plot:any=[]
  array_plot_show:any=[]
  checkall_plot=false
  array_pole:any=[]
  array_pole_show:any=[]
  checkall_pole=false
  // DATE-FILTER------------------------------
  // TABLE--------------------------------------
  tableColumns: string[] = ['record_date','farm','plot','pole','sum_good_data', 'sum_fail_data','sum_all_data' ];
  dataSource: MatTableDataSource < demo >
  data_table:any=[]
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  // TABLE--------------------------------------
 
  categorie_data:any=[]
  series_data:any=[]
  series_data_amount:any=[]
  data_plot_list:any=[]
  data_pole_list:any=[]
  data_export:any=[]
  btn_select_pole:boolean = true
  array_color = [
    "hsla(133,70%,75%,1)",
    "hsla(273,70%,75%,1)",
    "hsla(350,70%,75%,1)",
    "hsla(196,70%,75%,1)",
    "hsla(301,70%,75%,1)",
    "hsla(63,70%,75%,1)",
    "hsla(343,70%,75%,1)",
    "hsla(140,70%,75%,1)",
    "hsla(280,70%,75%,1)",
    "hsla(266,70%,75%,1)",
    "hsla(252,70%,75%,1)",
    "hsla(21,70%,75%,1)",
    "hsla(294,70%,75%,1)",
    "hsla(14,70%,75%,1)",
    "hsla(28,70%,75%,1)",
    "hsla(175,70%,75%,1)",
    "hsla(308,70%,75%,1)",
    "hsla(0,70%,75%,1)",
    "hsla(98,70%,75%,1)",
    "hsla(231,70%,75%,1)",
    "hsla(336,70%,75%,1)",
    "hsla(245,70%,75%,1)",
    "hsla(322,70%,75%,1)",
    "hsla(77,70%,75%,1)",
    "hsla(56,70%,75%,1)",
    "hsla(259,70%,75%,1)",
    "hsla(217,70%,75%,1)",
    "hsla(49,70%,75%,1)",
    "hsla(91,70%,75%,1)",
    "hsla(203,70%,75%,1)",
    "hsla(189,70%,75%,1)",
    "hsla(70,70%,75%,1)",
    "hsla(84,70%,75%,1)",
    "hsla(42,70%,75%,1)",
    "hsla(35,70%,75%,1)",
    "hsla(315,70%,75%,1)",
    "hsla(147,70%,75%,1)",
    "hsla(119,70%,75%,1)",
    "hsla(224,70%,75%,1)",
    "hsla(7,70%,75%,1)",
    "hsla(126,70%,75%,1)",
    "hsla(210,70%,75%,1)",
    "hsla(161,70%,75%,1)",
    "hsla(182,70%,75%,1)",
    "hsla(329,70%,75%,1)",
    "hsla(154,70%,75%,1)",
    "hsla(105,70%,75%,1)",
    "hsla(168,70%,75%,1)",
    "hsla(238,70%,75%,1)",
    "hsla(287,70%,75%,1)",
    "hsla(112,70%,75%,1)"
  ] 
  old_series_data:any = 0 
  updateFromInput:boolean = false

  constructor(
    private spinner: NgxSpinnerService,
    private _location: Location,
    private YieldReportService:YieldReportService,
    private route: ActivatedRoute,
  ) { 
    this.role = sessionStorage.getItem("role")
    this.org_id=sessionStorage.getItem("Org")
    this.farm_id =JSON.parse(this.route.snapshot.queryParams["farm_id"]);
    this.breed_type_id =JSON.parse(this.route.snapshot.queryParams["breed_type_id"]);
    this.child_org_id=sessionStorage.getItem("ChildOrg")
    this.createFilter()
    this.spinner.show()
  }

  ngOnInit(): void {
    this.getPlotList()
  }
  getPlotList(){
    this.selectedTypeData = 'data_sum'
    this.chartNodata()
    this.array_plot_show=[]
    this.array_plot=[]
    this.array_pole_show=[]
    this.array_pole=[]
    this.data_pole_list=[]
    let body ={
      "org_id": this.org_id,
      "child_org_id": this.child_org_id,
      "farm_ids": [this.farm_id],
      "breed_type_ids": [this.breed_type_id],
    }
    this.YieldReportService.getPlotList(body).subscribe(
      async result => {
        if (result.code == 200) {
          this.data_plot_list = result.data
          this.data_plot_list.map((item, index)=>{
              item.checkbox=true
              this.array_plot_show.push(item.name)
              this.array_plot.push(item._id)
          })
          this.checkall_plot = true
          this.getPoleList()
       
        }else{
         this.callErrorMSG()
        } 
      }
    )
  }
  getPoleList(){
  // if(this.selectedTypeDetail=='detail_pole'){
    this.array_pole_show=[]
    this.array_pole=[]
    this.data_pole_list=[]
    this.spinner.show()
    this.chartNodata()
    let body ={
      "org_id": this.org_id,
      "child_org_id": this.child_org_id,
      "farm_id": this.farm_id,
      "plot_ids": this.array_plot,
      "breed_type_id":this.breed_type_id,
    }
      this.YieldReportService.getPoleList(body).subscribe(
        async result => {
          if (result.code == 200) {

              this.data_pole_list = result.data
              if(this.selectedTypeDetail=='detail_pole'){
                  this.btn_select_pole=true
                  this.data_pole_list.map((item, index)=>{
                    item.checkbox=true
                    item.fullname = item.name+' - no.'+item.no
                    this.array_pole_show.push(item.fullname)
                    item.crop_pole_ids.map( item2 =>{
                      this.array_pole.push(item2)
                    })
                  })
              
              
                this.checkall_pole = true
                this.spinner.hide()
              
              }else{
                this.btn_select_pole=false
              }
              this.getData()
           
          }else{
            this.btn_select_pole=false
            this.chartNodata()
            this.getData()
          } 
          
        }
      )
  }
  getData(){
    this.data_table=[]
    this.dataSource = new MatTableDataSource(this.data_table);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.chartNodata()
    this.spinner.show()
    this.data_export=[]
    this.categorie_data = []
    let body ={
      "org_id": this.org_id,
      "child_org_id": this.child_org_id,
      "startDate": this.filter_date[0],
      "endDate": this.filter_date[this.filter_date.length-1],
      "farm_id": this.farm_id,
      "breed_type_id": this.breed_type_id,
      "plot_ids": this.array_plot,
      "crop_pole_ids":this.array_pole
    }

    if(this.selectedTypeDetail=='detail_plot'){
      delete body.crop_pole_ids
    }
      this.YieldReportService.getReportYieldDetail(body).subscribe(
        async result => {
          if (result.code == 200) {
            let yield_no = 0
            this.data_chart = []
            this.data_chart = result.data.charts
            this.group_data =[]
            this.series_data=[]
            this.setMissData(this.data_chart)
            this.data_table = result.data.tables
            this.setMissData(this.data_table) 
            if(this.selectedTypeData === 'data_sum'){
              yield_no = 1
            }else if(this.selectedTypeData === 'data_good'){
              yield_no = 2
            }else if(this.selectedTypeData === 'data_fail'){
              yield_no = 3
            }
            this.data_table.map(item=>{
              let date = new Date(item.record_date) 
              if(item.crop_pole_no){
                item.crop_pole_full = item.crop_pole_name +' - no.'+ item.crop_pole_no
              }else{
                item.crop_pole_full = ''
              }
              item.record_date = date.getUTCDate()+' '+this.format_month_fulleng(date.getUTCMonth()+1)+' '+date.getFullYear()
              item.month_year = this.format_month_fulleng(date.getUTCMonth()+1)+'-'+date.getFullYear()
              item.yields.map(item2=>{
                if(item2.no == 1 && item2.input_type == 'number' && this.checkEmpty(item2.value)){
                  item['sum_all_data'] = parseFloat(item2.value).toFixed(2)
                }else if(item2.no == 1 && item2.input_type == 'number' && !this.checkEmpty(item2.value)){
                  item['sum_all_data'] = 0
                }
                if(item2.no == 2 && item2.input_type == 'number' && this.checkEmpty(item2.value)){
                  item['sum_good_data'] = parseFloat(item2.value).toFixed(2)
                }else if(item2.no == 2 && item2.input_type == 'number' && !this.checkEmpty(item2.value)){
                  item['sum_good_data'] = 0
                }
                if(item2.no == 3 && item2.input_type == 'number' && this.checkEmpty(item2.value)){
                  item['sum_fail_data'] = parseFloat(item2.value).toFixed(2)
                }else if(item2.no == 3 && item2.input_type == 'number' && !this.checkEmpty(item2.value)){
                  item['sum_fail_data'] = 0
                }
              })
            })

            this.dataSource = new MatTableDataSource(this.data_table);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.dataSource.sortingDataAccessor = (item:any, property) => {
              switch (property) {
                case 'record_date': return new Date(item.record_date) ;
                case 'farm' : return item.farm_name ;
                case 'plot' : return item.plot_name ;
                case 'pole': return item.crop_pole_full ;
                case 'sum_good_data': return parseFloat(item.sum_good_data)  ;
                case 'sum_fail_data': return parseFloat(item.sum_fail_data) ;
                case 'sum_all_data': return parseFloat(item.sum_all_data) ;
                default: return item[property]; 
              }
            };
            
            this.data_table.map(item=>{
              this.data_export.push({
                record_date:'`'+item.record_date,
                farm_name:item.farm_name,
                plot_name:item.plot_name,
                crop_pole_no:item.crop_pole_full,
                sum_good_data:item.sum_good_data,
                sum_fail_data:item.sum_fail_data,
                sum_all_data:item.sum_all_data
              })
            })

        
            if(this.selectedTypeDetail === 'detail_plot'){
              this.data_chart.map(item =>{
                item.month_year = this.format_month_fulleng(parseInt(item.month))+'-'+item.year
                if(this.categorie_data.indexOf(item.month_year) == -1){
                  this.categorie_data.push(item.month_year)
                }
                if(this.group_data.indexOf(item.plot_name) == -1){
                  this.group_data.push(item.plot_name)
                }
              })
              this.group_data.map((item_plot,index)=>{
                this.series_data.push(
                  {
                    name:item_plot,data:[],
                    color:this.array_color[index] == undefined?  '': this.array_color[index],
                    events:{legendItemClick: function() {return false;}}
                  },
                )
              })
              this.series_data.map(series_item=>{ 
                this.categorie_data.map((item,index) =>{
                  series_item.data.push(0)
                  let sum_all_data = 0
                  this.data_chart.map(item2 =>{
                    if((item === item2.month_year) && (series_item.name == item2.plot_name)){
                        item2.yields.map(item3=>{
                          if(item3.no == yield_no  && this.checkEmpty(item3.value)){
                            sum_all_data += (parseFloat(item3.value.toFixed(2)))
                          }
                        })
                        series_item.data[index]= sum_all_data
                    }
                  })
                })
              })
       
          }else if(this.selectedTypeDetail === 'detail_pole'){
            this.data_table.map(item =>{
              if(this.categorie_data.indexOf(item.month_year) == -1){
                this.categorie_data.push(item.month_year)
              }
              if(this.group_data.indexOf(item.crop_pole_full) == -1){
                this.group_data.push(item.crop_pole_full)
              }
            })
            this.group_data.map((item,index)=>{
              this.series_data.push(
                {
                  name:item,data:[],
                  color:this.array_color[index] == undefined?  '': this.array_color[index],
                  events:{legendItemClick: function() {return false;}}
                },
              )
            })
            this.series_data.map(series_item=>{ 
              this.categorie_data.map((item,index) =>{
                series_item.data.push(0)
                let sum_all_data = 0
                this.data_table.map(item2 =>{
                  if((item === item2.month_year) && (series_item.name == item2.crop_pole_full)){
                      item2.yields.map(item3=>{
                        if(item3.no == yield_no  && this.checkEmpty(item3.value)){
                          sum_all_data += parseFloat(parseFloat(item3.value).toFixed(2))
                        }
                      })
                      series_item.data[index]= sum_all_data
                  }
                })
              })
            })
          }

            this.old_series_data = this.series_data.length
            this.Chart('','','','จำนวน')
            this.show_chart = true
            this.spinner.hide()
          }else{
           
            this.chartNodata()
            this.spinner.hide()
          } 
        }
      )

   
  }
  //--SUB-FUNCTION------------------------------------------------------------------------------------------------------------------------
  Back(){
    this._location.back();
  }
  changeDataType(){
    
    let yield_no = 0
    this.series_data=[]
    this.group_data.map((item,index)=>{
      this.series_data.push(
        {
          name:item,data:[],
          color:this.array_color[index] == undefined?  '': this.array_color[index],
          events:{legendItemClick: function() {return false;}}
        },
      )
    })
    this.Chart('','','','จำนวน')
    if(this.selectedTypeData === 'data_sum'){
      yield_no = 1
    }else if(this.selectedTypeData === 'data_good'){
      yield_no = 2
    }else if(this.selectedTypeData === 'data_fail'){
      yield_no = 3
    }

    if(this.selectedTypeDetail === 'detail_plot'){
        this.series_data.map(series_item=>{ 
          this.categorie_data.map((item,index) =>{
          series_item.data.push(0)
          let sum_data =0
          this.data_chart.map(item2 =>{
            if((item === item2.month_year) && (series_item.name == item2.plot_name)){
              item2.yields.map(item3=>{
                if(item3.no == yield_no  && this.checkEmpty(item3.value)){
                  sum_data += (parseFloat(item3.value.toFixed(2)))
                }
              })
              series_item.data[index]= sum_data
    
            }
          })
        })
      })
    }else if(this.selectedTypeDetail === 'detail_pole'){
      this.series_data.map(series_item=>{ 
        this.categorie_data.map((item,index) =>{
          series_item.data.push(0)
          let sum_data = 0
          this.data_table.map(item2 =>{
            if((item === item2.month_year) && (series_item.name == item2.crop_pole_full)){
                item2.yields.map(item3=>{
                  if(item3.no == yield_no  && this.checkEmpty(item3.value)){
                    sum_data += parseFloat(parseFloat(item3.value).toFixed(2))
                  }
                })
                series_item.data[index]= sum_data
            }
          })
        })
      })
    }
    


  }
 
  SelectCheckBox(name:any,id:any=null,index:any=null,type:any){
    if(type == 'plot'){
      if(name!='all'){
        if(this.array_plot_show.indexOf(name) == -1){
          this.array_plot_show=[]
          this.array_plot=[]
          this.data_plot_list.map(item=>{
            if(item._id == id){
              item.checkbox =true
            }
          })
          this.data_plot_list.map(item=>{
            if(item.checkbox == true){
              this.array_plot_show.push(item.name);
              this.array_plot.push(item._id);
            }
          })
        }else{
          this.array_plot_show.splice(this.array_plot_show.indexOf(name),1)
          this.array_plot.splice(this.array_plot.indexOf(id),1)
          this.data_plot_list.map(item=>{
            if(item._id == id){
              item.checkbox = false
            }
          })
        }
      }else{
        if(!this.checkall_plot){
          this.array_plot_show=[]
          this.array_plot=[]
            this.data_plot_list.map(item=>{
              item.checkbox=true
              this.array_plot_show.push(item.name)
              this.array_plot.push(item._id)
           })
           this.checkall_plot = true
        }else{
          this.array_plot_show=[]
          this.array_plot=[]
            this.data_plot_list.map(item=>{
              item.checkbox=false
          })
          this.checkall_plot = false
        }
      }
      this.CheckPlotCheckboxAll()
      this.getPoleList() 
      
    }else if(type == 'pole'){
      if(name!='all'){
        if(this.array_pole_show.indexOf(name) == -1){
          this.array_pole_show=[]
          this.array_pole=[]
          this.data_pole_list.map(item=>{
            if(item.pole_id == id){
              item.checkbox = true
            }
          })
           this.data_pole_list.map(item=>{
            if(item.checkbox == true){
              this.array_pole_show.push(item.fullname)
              item.crop_pole_ids.map( item2 =>{
                this.array_pole.push(item2)
              })
            }
          })
        }else{
          this.array_pole_show.splice(this.array_pole_show.indexOf(name),1)
          this.data_pole_list.map(item=>{
            if(item.pole_id == id){
              item.checkbox = false
              item.crop_pole_ids.map( item2 =>{
                this.array_pole.splice(this.array_pole.indexOf(item2),1)
              })
            }
          })
        }
      }else{
        if(!this.checkall_pole){
          this.data_pole_list.map(item=>{
            item.checkbox=false
          })
          this.array_pole_show=[]
          this.array_pole=[]
          this.data_pole_list.map(item=>{
              item.checkbox=true
              this.array_pole_show.push(item.fullname)
              item.crop_pole_ids.map( item2 =>{
                this.array_pole.push(item2)
              })
          })
          this.checkall_pole = true
        }else{
          this.array_pole_show=[]
          this.array_pole=[]
          this.data_pole_list.map(item=>{
              item.checkbox=false
          })
          this.checkall_pole = false
        }
        
      }
      this.CheckPoleCheckboxAll()
      this.getData()
     
    }
    
  }
  CancelSelect(name:any,type:any){
    if(type == 'plot'){
      let array_plot_delete=[]
      this.array_plot_show.splice(this.array_plot_show.indexOf(name),1)
      this.data_plot_list.map(item=>{
        if(item.name == name){
          item.checkbox = false
          this.array_plot.splice(this.array_plot.indexOf(item._id),1)
          this.data_pole_list.map((item2,index)=>{
            if(item2.plot_id == item._id){
              item2.checkbox = false
              array_plot_delete.push(index)
              if(this.array_pole_show.indexOf(item2.fullname) != -1){
                this.array_pole_show.splice(this.array_pole_show.indexOf(item2.fullname),1)
                item2.crop_pole_ids.map( item3 =>{
                  this.array_pole.splice(this.array_pole.indexOf(item3),1)
                })
              }
       
            }
          })
        }
      })
      array_plot_delete.reverse().map(item=>{
        this.data_pole_list.splice(item,1)
      })
      this.CheckPlotCheckboxAll()
    }else if(type =='pole'){
      this.array_pole_show.splice(this.array_pole_show.indexOf(name),1)
      this.data_pole_list.map(item2=>{
        if(item2.fullname == name){
          item2.checkbox = false
          item2.crop_pole_ids.map( item3 =>{
            this.array_pole.splice(this.array_pole.indexOf(item3),1)
          })
        }
      })
      this.CheckPoleCheckboxAll()
 
    }

    if(this.array_plot.length==0){
      this.array_pole=[]
      this.data_pole_list=[]
    }
    this.getData()



    
  }
 
  Chart(type:string,Title:string,xTitle:string,yTitle:string){
    let time_now = new Date()
    let image_name = 'กราฟแสดงผลรวมผลดีผลเสียผลรวม-' + (time_now.getDate() < 10 ? ('0' + time_now.getDate()) : time_now.getDate()) + '-' + ((time_now.getMonth() + 1) < 10 ? ('0' + (time_now.getMonth() + 1)) : (time_now.getMonth() + 1)) + '-' + time_now.getFullYear() + '[' + (time_now.getHours() < 10 ? ('0' + time_now.getHours()) : time_now.getHours()) + '-' + (time_now.getMinutes() < 10 ? ('0' + time_now.getMinutes()) : time_now.getMinutes()) + "]";
    let menuItems = [];
    if(this.role == 'admin' || this.role == 'farm_manager'){
      menuItems = [
        'downloadJPEG', 'downloadPNG', 'viewFullscreen'
      ]
    }else{
      menuItems = [
        'viewFullscreen'
      ]
    }

    Highcharts.setOptions({
      lang: {
        thousandsSep: ',',
        noData: 'ไม่พบข้อมูล'
      }
    });
    this.chartOptions= {   
      exporting: {
        fallbackToExportServer: false,
        enabled: true,
        filename: image_name,
        buttons: {
          contextButton: {
            menuItems: menuItems
          },
        }
      },
      chart: {
          type:type,
          style: {
            fontFamily: 'Kanit',
          },events: {
            beforePrint: function() {
              this.setSize(1000, null, false)
            },
            afterPrint: function() {
              this.setSize(null, null, false)
            }
          }
      },
       legend: {
         align: 'left',
         verticalAlign: 'top',
         itemMarginLeft: 10,
         itemMarginBottom: 10,
         
       },
      title: {
        text:Title,
        style: {
          fontSize:'15px',
          fontWeight:'bold'
        },
        align: 'left',
      },
      xAxis: {
         title: {
              text: xTitle
          },
          categories:this.categorie_data,
          crosshair: true,
      },
      yAxis: {
  
          min: 0,
          title: {
              text: yTitle
          },
      },
      rangeSelector: {
        allButtonsEnabled: true,
        selected: 1
      },
      tooltip: {
          headerFormat: '<span >{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}&nbsp;:&nbsp;</td>' +
              '<td style="padding:0"><b>{point.y}</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
      },
      plotOptions: {
          column: {
              pointPadding: 0.1,
              borderWidth: 0,
          }
      },
  
      series:this.series_data
     };

     
  }
  CheckPlotCheckboxAll(){
    if(this.array_plot.length == 0){
      this.checkall_plot = false
      this.checkall_pole = false
    }
    if(this.data_plot_list.length == this.array_plot.length){
      this.checkall_plot = true
    }else{
      this.checkall_plot = false
    }
  }
  CheckPoleCheckboxAll(){
    if(this.array_pole_show.length == 0){
      this.checkall_pole = false
    }
    if(this.data_pole_list.length == this.array_pole_show.length){
      this.checkall_pole = true
    }else{
      this.checkall_pole = false
    }
  }
  
  Selectmonth(year,number,month,disable,type,select_month:HTMLElement){
    this.last_select_month=select_month
    if(disable == false && type =='start'){
      this.filter_monthyear_start_show = month+'-'+year
      this.filter_monthyear_start = number+'/1/'+year
      this.myDivstart.nativeElement.className = 'dropdown-menu'
      this.yearselect_start = year
      this.format_filterdate()
      if(this.before_data_month_start){
        if(this.before_data_month_start.textContent != month){
          this.before_data_month_start.className = this.rollback_css
          select_month.className = this.active_css
          this.before_data_month_start = select_month
        }
      }else{
        this.before_data_month_start = select_month
        select_month.className = this.active_css
      }
    }else if(disable == false && type =='end'){
      this.filter_monthyear_end_show = month+'-'+year
      this.filter_monthyear_end = number+'/1/'+year
      this.myDivend.nativeElement.className = 'dropdown-menu'
      this.format_filterdate()
      if(this.before_data_month_end){
        if(this.before_data_month_end.textContent != month){
          this.before_data_month_end.className = this.rollback_css
          select_month.className = this.active_css
          this.before_data_month_end = select_month
        }
      }else{
        this.before_data_month_end = select_month
        select_month.className = this.active_css
      }
    }

  }
  async createFilter(){
    let today =  new Date();
    let format_array=[]
    let year_array =[]
    let month_array =[]
    let year_now = today.getFullYear()
    let month_now = today.getMonth()+1
    let limit_year = 2
    let limit_month = limit_year * 12
    let chek_month_limit = false
    format_array.push(month_now)
    for(let i = 1;i <= limit_month ;i++ ){
      let num = Math.abs(month_now-i)
      if(num == 13){
        chek_month_limit= true
      }
      if(num != 0 ){
        format_array.push(num)
      }
    }
    var p1 = format_array.slice(0,month_now);
    p1 = p1.reverse();
    var p2 = format_array.slice(month_now,(12+month_now));
    var p3:any

    for(let i = 0 ;i < 12 ;i++){
      if(p1[i]!=undefined && p1[i]!='' && p1[i]!=null){
        p1[i]={
          number:p1[i],
          month:this.format_month_eng(p1[i]),
          disable:false
        }
      }else{
        p1[i]={
          number:i+1,
          month:this.format_month_eng(i+1),
          disable:true
        }
      }
      if(p2[i]!=undefined && p2[i]!='' && p2[i]!=null){
        p2[i]={
          number:p2[i],
          month:this.format_month_eng(p2[i]),
          disable:false
        }
      }else{
        p2[i]={
          number:i+1,
          month:this.format_month_eng(i+1),
          disable:true
        }
      } 
    }
    month_array.push(p1,p2)
    if(chek_month_limit){
        p3 = format_array.slice((12+month_now),limit_month);
        for(let i = 0;i < p3.length ;i++ ){
          p3[i] = parseInt(p3[i])-p3.length
        }
        let minus=(p3.length-1)
        for(let i = 0 ;i < 12 ;i++){
          if(p3[i]==undefined || p3[i]=='' || p3[i]==null){
            p3[i]={
              number:i-minus,
              month:this.format_month_eng(i-minus),
              disable:true
            }
          }else{
            p3[i]={
              number:p3[i],
              month:this.format_month_eng(p3[i]),
              disable:false
            }
          }
        }
      p3.sort(function (a, b) {
        return a.number - b.number;
      });
      month_array.push(p3)
    }
 
    month_array.reverse()
    for(let i = month_array.length ;i >= 1 ;i-- ){
      year_array.push((year_now+1)-i)
    }
    await Promise.all( year_array.map((item,index)=>{
      year_array[index]={
       year:item,
       month:month_array[index]
      }
    }))
    this.format_month_year = year_array  
    let start_month_number = ''
    let start_month = ''
    let end_month_number = ''
    let end_month = ''
    let last_index = this.format_month_year.length-1
    for(let i = 0; i < this.format_month_year[0].month.length ;i++){
      if(this.format_month_year[0].month[i].disable == false){
        start_month_number=this.format_month_year[0].month[i].number
        start_month =this.format_month_year[0].month[i].month
        break;
      }
    } 
    for(let i = this.format_month_year[last_index].month.length -1; i >= 0 ;i--){
      if(this.format_month_year[last_index].month[i].disable == false){
        end_month_number=this.format_month_year[last_index].month[i].number
        end_month =this.format_month_year[last_index].month[i].month
        break;
      }
    }
    this.filter_monthyear_start_show = start_month+'-'+this.format_month_year[0].year
    this.filter_monthyear_start = start_month_number+'/1/'+this.format_month_year[0].year
    this.filter_monthyear_end_show = end_month+'-'+this.format_month_year[last_index].year
    this.filter_monthyear_end = end_month_number+'/1/'+this.format_month_year[last_index].year

    this.format_filterdate()

  }
  clear_filetr_date(){
    this.filter_monthyear_start = ''
    this.filter_monthyear_end = ''
    this.filter_monthyear_start_show = ''
    this.filter_monthyear_end_show = ''
    this.createFilter()
  }
  format_filterdate(){ 
    if(
    (this.filter_monthyear_start !=null  && this.filter_monthyear_start != '' && this.filter_monthyear_start != undefined)&& 
    (this.filter_monthyear_end !=null  && this.filter_monthyear_end != '' && this.filter_monthyear_end != undefined)&&
    (new Date(this.filter_monthyear_start) > new Date(this.filter_monthyear_end))){
      Swal.fire({
        icon: 'warning',
        title: 'วันที่ไม่ถูกต้อง',
        showConfirmButton: false,
        timer: 3000
      })
      this.clear_filetr_date()

    }else if((this.filter_monthyear_start !=null  && this.filter_monthyear_start != '' && this.filter_monthyear_start != undefined)&& 
    (this.filter_monthyear_end !=null  && this.filter_monthyear_end != '' && this.filter_monthyear_end != undefined)){
        this.filter_date=[]
        let d1 = new Date(this.filter_monthyear_start) 
        let d2 = new Date(this.filter_monthyear_end)  
        var months;
        let cap = 0
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth();
        months += d2.getMonth();
        
        cap = months <= 0 ? 0 : months
        var month:any =0
        var limit_month = 12
        var year = d1.getFullYear()
          for(let i=0 ;i <= cap;i++){
             month = d1.getMonth()+1+i <= 9 ? '0'+(d1.getMonth()+1+i):(d1.getMonth()+1+i)
           
             if(month > limit_month){
              month = month-limit_month <= 9 ? '0'+(month-limit_month):month-limit_month
             }
             if(month > 12 ){
              month = month-12 <= 9 ? '0'+(month-12):month-12
              limit_month +=12
             }
            if(parseInt(month) == 1 ){
                year +=1
            }
            this.filter_date.push(year+'-'+month)
          }
          let check_first =this.filter_date[0].split('-')
          if(this.filter_date.length <=12){
            if(parseInt(check_first[1])==1){ 
              this.filter_date.map((item,index)=>{
              let split = item.split('-')
              this.filter_date[index]=this.yearselect_start+'-'+split[1]
              })
            }
          }else{
            if(parseInt(check_first[1])==1 && this.filter_date.length >12){
              this.filter_date.map((item,index)=>{
                let split = item.split('-')
                this.filter_date[index]=(parseInt(split[0])-1)+'-'+split[1]
                })
            }
          }
          this.getData()
    }
  }
  format_month_eng(data){
    // data.map(obj=>{
      switch (data) {
        case 1:
          data = 'Jan.'
          break;
        case 2:
          data = 'Feb.'
          break;
        case 3:
          data = 'Mar.'
          break;
        case 4:
          data = 'Apr.'
          break;
        case 5:
          data = 'May.'
          break;
        case 6:
          data = 'Jun.'
          break;
        case 7:
          data = 'Jul.'
          break;
        case 8:
          data = 'Aug.'
          break;
        case 9:
          data = 'Sep.'
          break;
        case 10:
          data = 'Oct.'
          break;
        case 11:
          data = 'Nov.'
          break;
        case 12:
          data = 'Dec.'
          break;
      }
    // })
    return data
  }
  format_month_fulleng(data){
    // data.map(obj=>{
      switch (data) {
        case 1:
          data = 'January'
          break;
        case 2:
          data = 'February'
          break;
        case 3:
          data = 'March'
          break;
        case 4:
          data = 'April'
          break;
        case 5:
          data = 'May'
          break;
        case 6:
          data = 'June'
          break;
        case 7:
          data = 'July'
          break;
        case 8:
          data = 'August'
          break;
        case 9:
          data = 'September'
          break;
        case 10:
          data = 'October'
          break;
        case 11:
          data = 'November'
          break;
        case 12:
          data = 'December'
          break;
      }
    // })
    return data
  }
  chartNodata(){
    this.series_data=[]
    for(let i = 0 ; i < this.old_series_data ;i++){
      this.series_data.push(
        {
          name:'',data:[],
          events:{legendItemClick: function() {return false;}}
        }
      )
    }
    this.Chart('','','','จำนวน')
  }
  format_export(type:any){
    if(this.role=='farm_manager' || this.role=='admin'){
      this.spinner.show
      if(type =='csv'){
        const header = ['วันที่บันทึกผล','ฟาร์ม','แปลง','เสา/ต้น','ผลดี','ผลเสีย','ผลรวม']
            let time_now =new Date()
            const replacer = (key, value) => (value === null ? '' : value);
            const datalist = Object.keys(this.data_export[0]);
            const csv = this.data_export.map((row) =>
            datalist
                .map((fieldName) => JSON.stringify(row[fieldName], replacer))
                .join(',')
            );
            csv.unshift(header.join(','));
            const csvArray = csv.join('\r\n');
            var link = window.document.createElement("a");
            link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvArray));
            link.setAttribute("download", 'รายงานบันทึกผลผลิต'+'-'+(time_now.getDate() < 10 ? ('0'+time_now.getDate() ): time_now.getDate() )+'-'+((time_now.getMonth()+1) < 10 ? ('0'+(time_now.getMonth()+1) ): (time_now.getMonth()+1))+'-'+time_now.getFullYear()+'('+(time_now.getHours() < 10 ? ('0'+time_now.getHours() ): time_now.getHours() )+ '-' + (time_now.getMinutes() < 10 ? ('0'+time_now.getMinutes() ): time_now.getMinutes() )+")"+".csv");
            link.click();
            link.remove();
            this.spinner.hide()
      }else if(type =='xlsx'){
          var td=''
          this.data_export.map(data=>{
            td += 
            '<tr>'
            +'<td>'+data.record_date+'</td>'
            +'<td>'+data.farm_name+'</td>'
            +'<td>'+data.plot_name+'</td>'
            +'<td>'+data.crop_pole_no+'</td>'
            +'<td>'+data.sum_good_data+'</td>'
            +'<td>'+data.sum_fail_data+'</td>'
            +'<td>'+data.sum_all_data+'</td>'
            +'</tr>'
          })
  
          var element2 = `<table > 
          <tr >       
              <th >วันที่บันทึกผล</th> 
              <th >ฟาร์ม</th> 
              <th >แปลง</th>  
              <th >เสา/ต้น</th> 
              <th >ผลดี</th> 
              <th >ผลเสีย</th> 
              <th >ผลรวม</th> 
          </tr>`+td+    
          `</table>`; 
  
  
            let time_now =new Date()
            let sheet_name = 'รายงานบันทึกผลผลิต'+'-'+(time_now.getDate() < 10 ? ('0'+time_now.getDate() ): time_now.getDate() )+
            '-'+((time_now.getMonth()+1) < 10 ? ('0'+(time_now.getMonth()+1) ): (time_now.getMonth()+1))+'-'+time_now.getFullYear()
            +'('+(time_now.getHours() < 10 ? ('0'+time_now.getHours() ): time_now.getHours() )+ '-' + 
            (time_now.getMinutes() < 10 ? ('0'+time_now.getMinutes() ): time_now.getMinutes() )+')'
            let parser = new DOMParser();
            let doc = parser.parseFromString(element2, 'text/html');
            const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(doc);
            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            let sheet_name_split :any =''
            if(sheet_name.length > 31){
              sheet_name_split= sheet_name.slice(0, 31)
            }
            XLSX.utils.book_append_sheet(wb, ws, sheet_name_split);
            XLSX.writeFile(wb, sheet_name+'.xlsx');
            this.spinner.hide()
      }
    }
    
  }
  callErrorMSG(){
    Swal.fire({
      icon: 'error',
      title: 'เกิดข้อผิดพลาดในการเรียกข้อมูล',
      showConfirmButton: false,
      timer: 3000
    })
    this.spinner.hide()  
  }
  checkEmpty(data){
    if(data !=0 && data != null && data != '' && data != undefined ){
      return true
    }else{
      return false
    }
  }

  setMissData(array){
    array.map((item) => {
      let index_all = item.yields.findIndex(x => x.no == 1 );
      let index_good = item.yields.findIndex(x => x.no == 2 );
      let index_fail = item.yields.findIndex(x => x.no == 3 );
      item.yields.map(item2=>{
        if(!this.checkEmpty(item2.value)){
          if(item2.no == 1){ // ค่า all ไม่มี
            if(this.checkEmpty(item.yields[index_good].value) && this.checkEmpty(item.yields[index_fail].value)){ // แต่มีค่า good และ fail
              item2.value = parseFloat(item.yields[index_good].value) + parseFloat(item.yields[index_fail].value)
            }else if(!this.checkEmpty(item.yields[index_good].value) && this.checkEmpty(item.yields[index_fail].value)){ //ไม่มีค่า good แต่มี fail
              item2.value = parseFloat(item.yields[index_fail].value)
            }else if(this.checkEmpty(item.yields[index_good].value) && !this.checkEmpty(item.yields[index_fail].value)){ //มีค่า good แต่ไม่มี fail
              item2.value = parseFloat(item.yields[index_good].value)
            }
          }
          if(item2.no == 2){// ค่า good ไม่มี
            if(this.checkEmpty(item.yields[index_all].value) && this.checkEmpty(item.yields[index_fail].value)){ // แต่มีค่า all และ fail
              item2.value = parseFloat(item.yields[index_all].value) - parseFloat(item.yields[index_fail].value)
            }else if(this.checkEmpty(item.yields[index_all].value) && !this.checkEmpty(item.yields[index_fail].value)){ //มีค่า all แต่ไม่มี fail
              item2.value = parseFloat(item.yields[index_all].value)
            }
          }
          if(item2.no == 3){// ค่า fail ไม่มี
            if(this.checkEmpty(item.yields[index_all].value) && this.checkEmpty(item.yields[index_good].value)){ // แต่มีค่า all และ good
              item2.value = parseFloat(item.yields[index_all].value) - parseFloat(item.yields[index_good].value)
            }
          }

        }
      })
    })
  }












}
